(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("adminResourcesController", adminResourcesController);

  adminResourcesController.$inject = [
    "Resources",
    "ResourcesApi",
    "SettingsApi",
    "alerts",
  ];

  function adminResourcesController(
    Resources,
    ResourcesApi,
    SettingsApi,
    alerts,
  ) {
    var vm = this;

    // properties
    vm.isLoading = false;
    vm.resources = {};
    vm.filters = {
      // title: '',
      status: "",
      // only_active: 0,
      page: 1,
      page_size: 15,
      with: "user",
    };
    vm.statusOptions = [
      { label: "All", value: "" },
      { label: "Pending", value: "pending" },
      { label: "Approved", value: "approved" },
      { label: "Rejected", value: "rejected" },
    ];

    // methods
    vm.getResources = getResources;
    vm.createResource = createResource;
    vm.editResource = editResource;

    /**
     * Retrieves resources from the API
     *
     * @return {void}
     */
    function getResources() {
      vm.isLoading = true;

      ResourcesApi.get(
        vm.filters,
        function handleGetResourcesResponse(response) {
          vm.resources = response;
          vm.isLoading = false;
        },
        function handleGetResourcesError() {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Shows the create resource modal then refreshes the data
     *
     * @return {void}
     */
    function createResource() {
      Resources.manageResource().then(getResources);
    }

    /**
     * Shows the edit resource modal then refreshes the data
     *
     * @param  {Number} poll - ID of resource to edit
     * @return {void}
     */
    function editResource(resourceId) {
      Resources.manageResource(resourceId).then(function (updatedResource) {
        // Find and update the resource on this page
        angular.forEach(vm.resources.data, function (resource, index) {
          if (resource.id === resourceId) {
            if (!updatedResource) {
              // resource was deleted
              return vm.resources.data.splice(index, 1);
            }

            vm.resources.data[index] = angular.merge(
              vm.resources.data[index],
              updatedResource,
            );
          }
        });
      });
    }

    // init
    getResources();
  }
})(angular);
